import HTTP from '@rocketfid/api'

const state = {
  items: []
}

// getters
const getters = {
  monsters: (state) => {
    return state.items
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  }
}

// actions
const actions = {
  loadMonsters ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .monster.getAll()
      .then((monsters) => {
        dispatch('monsters/resetMonsters', null, { root: true })
        commit('ADD_MONSTER_ITEMS', { items: monsters })
        return monsters
      })
  },

  resetMonsters ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_MONSTER_ITEMS')
      resolve()
    })
  },

  addMonster ({ commit, rootGetters }, { monster }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .monster.create(monster)
      .then((monster) => {
        commit('ADD_MONSTER_ITEM', { item: monster })
        return monster
      })
  },

  updateMonster ({ commit, rootGetters }, { monster }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .monster.update(monster)
      .then((monster) => {
        commit('UPDATE_MONSTER_ITEM', { item: monster })
        return monster
      })
  },

  removeMonster ({ commit, rootGetters }, { monster }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .monster.delete(monster)
      .then((monster) => {
        commit('REMOVE_MONSTER_ITEM', { item: monster })
        return monster
      })
  }
}

// mutations
const mutations = {
  ADD_MONSTER_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_MONSTER_ITEMS: (state) => {
    state.items = []
  },

  ADD_MONSTER_ITEM: (state, { item }) => {
    state.items.push(item)
  },

  UPDATE_MONSTER_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
      }
    }
  },
  REMOVE_MONSTER_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/monsters.js